import { Component } from "@angular/core";
import { EceButtonComponent } from "./ece.button.component";

@Component({
    selector: "ece-btn",
    templateUrl: "./ece.button.component.html",
    standalone: false
})
export class ButtonComponent extends EceButtonComponent {
  primary = false;
}
